<template>
  <v-slide-y-reverse-transition>
    <v-card v-if="value" ref="promptCard" v-click-outside="onClickOutside"
      class="like-prompt-card elevation-8 pa-4" max-width="340">

      <!-- Estado: Gracias -->
      <div v-if="done" class="text-center">
        <v-icon size="36" :color="doneColor">{{ doneIcon }}</v-icon>
        <p class="body-2 mt-2 mb-0">{{ doneMsg }}</p>
      </div>

      <!-- Estado: Principal -->
      <div v-else>
        <div class="d-flex align-center mb-2">
          <v-icon color="red lighten-1" class="mr-2">mdi-heart</v-icon>
          <span class="body-2 font-weight-medium">¿Te gustó este artículo?</span>
          <v-spacer></v-spacer>
          <v-btn icon x-small @click="cerrar">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Botón Me Gusta siempre visible -->
        <v-btn color="red" dark small block :loading="likingLoading" @click="onClickLike" class="mb-2">
          <v-icon left small>mdi-heart</v-icon> Me Gusta
        </v-btn>

        <!-- Sección login (aparece si no está logueado y clickeó like) -->
        <div v-if="showLogin">
          <v-divider class="my-2"></v-divider>
          <p class="caption grey--text text--darken-1 mb-2">Para dar Me Gusta, iniciá sesión:</p>

          <v-form ref="loginForm" @submit.prevent="loginManual">
            <v-text-field v-model="email" label="Email" type="email" outlined dense
              :rules="[v => !!v || 'Requerido']" prepend-inner-icon="mdi-email"
              class="mb-1" hide-details="auto"></v-text-field>
            <v-text-field v-model="password" label="Contraseña" type="password" outlined dense
              :rules="[v => !!v || 'Requerido']" prepend-inner-icon="mdi-lock"
              class="mb-2" hide-details="auto"></v-text-field>
            <v-btn color="teal" dark small block :loading="loginLoading" type="submit">
              Iniciar Sesión
            </v-btn>
          </v-form>

          <div class="my-2 d-flex align-center">
            <v-divider></v-divider>
            <span class="mx-2 caption grey--text">o</span>
            <v-divider></v-divider>
          </div>

          <v-btn outlined small color="blue" block @click="loginGoogle">
            <v-icon left small>mdi-google</v-icon> Google
          </v-btn>

          <v-alert v-if="loginError" type="error" dense text class="mt-2 mb-0 caption">
            {{ loginError }}
          </v-alert>
        </div>
      </div>
    </v-card>
  </v-slide-y-reverse-transition>
</template>

<script>
import { http } from '@/services/config';
import forumService from '@/services/forumService.js';

export default {
  name: 'BlogLikePrompt',
  props: {
    value: { type: Boolean, default: false },
    postId: { type: [Number, String], default: null }
  },
  data() {
    return {
      showLogin: false,
      done: false,
      doneMsg: '',
      doneIcon: 'mdi-check-circle',
      doneColor: 'green',
      email: '',
      password: '',
      loginLoading: false,
      likingLoading: false,
      loginError: ''
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.estaLogueado;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.showLogin = false;
        this.done = false;
        this.email = '';
        this.password = '';
        this.loginError = '';
      }
    }
  },
  methods: {
    onClickOutside() {
      // Solo cerrar si no está mostrando el login (evitar cerrar accidentalmente)
      if (!this.showLogin) {
        this.cerrar();
      }
    },
    onClickLike() {
      if (this.isLoggedIn) {
        this.darLike();
      } else {
        this.showLogin = true;
      }
    },
    darLike() {
      if (!this.postId) return;
      this.likingLoading = true;
      forumService.likePostOnly(this.postId).then(res => {
        this.done = true;
        if (res.data.already_liked) {
          this.doneMsg = '¡Ya habías dado Me Gusta! ❤️';
          this.doneIcon = 'mdi-heart';
          this.doneColor = 'red';
        } else {
          this.doneMsg = '¡Gracias por tu apoyo!';
          this.doneIcon = 'mdi-check-circle';
          this.doneColor = 'green';
          this.$emit('liked');
        }
        setTimeout(() => { this.cerrar(); }, 2500);
      }).catch(() => {
        this.loginError = 'Error al dar Me Gusta';
      }).finally(() => {
        this.likingLoading = false;
      });
    },
    loginManual() {
      if (!this.$refs.loginForm.validate()) return;
      this.loginLoading = true;
      this.loginError = '';

      http.post('api/login', { email: this.email, password: this.password }, { skipAuthInterceptor: true })
        .then(res => {
          const data = res.data;
          localStorage.setItem('token', data.token || (data.data && data.data.token));
          this.$store.commit('setLogueado', true);
          if (data.identificador || (data.data && data.data.identificador)) {
            this.$store.commit('setIdentificador', data.identificador || data.data.identificador);
          }
          this.showLogin = false;
          this.darLike();
        })
        .catch(err => {
          this.loginError = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Email o contraseña incorrectos';
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },
    loginGoogle() {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        window.google.accounts.id.prompt((notification) => {
          if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            this.loginError = 'Google no disponible. Use email/contraseña.';
          }
        });
        const unwatch = this.$watch(
          () => this.$store.getters.estaLogueado,
          (logueado) => {
            if (logueado) {
              unwatch();
              this.showLogin = false;
              this.darLike();
            }
          }
        );
      } else {
        this.loginError = 'Google no disponible. Use email/contraseña.';
      }
    },
    cerrar() {
      this.$emit('input', false);
    }
  }
};
</script>

<style scoped>
.like-prompt-card {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 100;
  border-radius: 12px !important;
}
</style>
